import { Image, StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';
import commonStyles from '../../Common/commonStyles';
import Details from './Details';
const styles = StyleSheet.create({
    detailsContainer: {
        height: '25%',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginHorizontal: commonStyles.marginHorizontal,
        marginBottom: '4%',
    },
    image: {
        objectFit: 'contain',
        width: '50%',
        padding: '2.5% 5%',
        border: '1px solid #b8b8b8',
    },
});
function DetailsPage({ specification }) {
    const { title, code, brand, category, season, specificationTeamMembersNode, mainPhoto } = specification;
    return (React.createElement(View, { style: styles.detailsContainer },
        React.createElement(Image, { style: styles.image, src: mainPhoto }),
        React.createElement(Details, { admins: specificationTeamMembersNode === null || specificationTeamMembersNode === void 0 ? void 0 : specificationTeamMembersNode.adminName, brand: brand, category: category, code: code, designers: specificationTeamMembersNode === null || specificationTeamMembersNode === void 0 ? void 0 : specificationTeamMembersNode.designerName, patternMaker: specificationTeamMembersNode === null || specificationTeamMembersNode === void 0 ? void 0 : specificationTeamMembersNode.patternerName, season: season, title: title })));
}
export default DetailsPage;
